module.exports = __webpack_public_path__ + "img/20191125164444967.239268dd.jpg";